import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { QuestProvider } from '@questlabs/react-sdk';
import '@questlabs/react-sdk/dist/style.css';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AppHelp from './components/help/HelpHub';
import Home from './pages/Home';
import App from './pages/App';
import Dashboard from './pages/Dashboard';
import Pricing from './pages/Pricing';
import WatchDemo from './pages/WatchDemo';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import questConfig from './config/questConfig';
import './App.css';

function AppRouter() {
  return (
    <QuestProvider 
      apiKey={questConfig.APIKEY}
      entityId={questConfig.ENTITYID}
      apiType="PRODUCTION"
    >
      <AuthProvider>
        <DataProvider>
          <Router>
            <div className="min-h-screen bg-black text-light">
              <Header />
              <AnimatePresence mode="wait">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/app" element={<App />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/watch-demo" element={<WatchDemo />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                </Routes>
              </AnimatePresence>
              <Footer />
              <AppHelp />
            </div>
          </Router>
        </DataProvider>
      </AuthProvider>
    </QuestProvider>
  );
}

export default AppRouter;